import { NgModule } from "@angular/core";
import { BannerCardComponent } from "@modules/shared/banner-card-module/banner-card.component";
import { CoreModule } from "@modules/core/core.module";

const components = [BannerCardComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [components],
	exports: [components]
})
export class BannerCardModule {}
